export default __webpack_public_path__ + "static/media/tickets.31485f83.svg";